import { Conversation } from '../../../types';
import { cn } from '../../../lib/utils';
import { numberForConversation, useMultipleWhatsAppNumbers } from '../hooks/useWhatsAppNumbers';

interface WhatsAppNumberBadgeProps {
  conversation: Conversation;
  className?: string;
}

/** A small pill naming the business number ("Abuja") a conversation is on. */
export default function WhatsAppNumberBadge({ conversation, className }: WhatsAppNumberBadgeProps) {
  const numbers = useMultipleWhatsAppNumbers();
  if (!numbers.length) return null;
  const number = numberForConversation(conversation, numbers);
  const name =
    conversation.whatsappNumberLabel || number?.label || number?.displayNumber || null;
  if (!name) return null;
  return (
    <span
      className={cn(
        'inline-flex flex-shrink-0 items-center whitespace-nowrap rounded-xs border border-line bg-surface-2 px-1.5 py-0.5 text-[10px] font-medium text-ink-2',
        className
      )}
      title={number?.displayNumber ? `On ${number.displayNumber}` : undefined}
    >
      {name}
    </span>
  );
}
